// Municipality name must match exactly the `name` field in countries.ts
import { countries, Country } from "./countries";

export interface SloganEntry {
  municipality: string;
  slogan: string;
}

export const SLOGANS: SloganEntry[] = [
  { municipality: "Alstahaug", slogan: "Et historisk sted med nye muligheter" },
  { municipality: "Alvdal", slogan: "Der det vanskelige er en bagatell og det umulige en utfordring" },
  { municipality: "Alver", slogan: "Bygd på fortida – for framtida" },
  { municipality: "Aremark", slogan: "Midt i naturen" },
  { municipality: "Arendal", slogan: "Varm, stolt og utadvendt" },
  { municipality: "Asker", slogan: "Mulighetenes kommune" },
  { municipality: "Askvoll", slogan: "Rom for eventyr!" },
  { municipality: "Askøy", slogan: "En kulturkommune i vekst" },
  { municipality: "Aukra", slogan: "Full av energi" },
  { municipality: "Aure", slogan: "Vill, Vakker og Vennlig" },
  { municipality: "Aurland", slogan: "Det naturlege valet" },
  { municipality: "Aurskog-Høland", slogan: "Muligheter, miljø og mangfold" },
  { municipality: "Averøy", slogan: "En god forbindelse" },
  { municipality: "Balsfjord", slogan: "For framtida" },
  { municipality: "Bamble", slogan: "Stadig bedre" },
  { municipality: "Bardu", slogan: "Trivsel og kvalitet i friske omgivelser" },
  { municipality: "Beiarn", slogan: "Fremtiden skapes nå" },
  { municipality: "Berlevåg", slogan: "Heftig og begeistret" },
  { municipality: "Birkenes", slogan: "Trygghet og trivsel" },
  { municipality: "Bjørnafjorden", slogan: "Bli inspirert" },
  { municipality: "Bodø", slogan: "Bodø i vinden" },
  { municipality: "Bremanger", slogan: "Trivselskommunen ved havet" },
  { municipality: "Brønnøy", slogan: "Midt i leia, midt i landet" },
  { municipality: "Bygland", slogan: "Med hjarta i Bygland" },
  { municipality: "Bykle", slogan: "Bykle ser langt" },
  { municipality: "Bømlo", slogan: "Driftige folk i vakker natur!" },
  { municipality: "Båtsfjord", slogan: "Fiskerihovedstaden" },
  { municipality: "Drammen", slogan: "Et godt sted å leve" },
  { municipality: "Drangedal", slogan: "Driv, Drøm, Dugnad" },
  { municipality: "Dyrøy", slogan: "Den lærende kommune" },
  { municipality: "Eidfjord", slogan: "Unik frå fjell til fjord" },
  { municipality: "Eidskog", slogan: "For framtidas generasjoner" },
  { municipality: "Eidsvoll", slogan: "På historisk grunn inn i framtida" },
  { municipality: "Eigersund", slogan: "Sammen for alle" },
  { municipality: "Elverum", slogan: "Elverum har hjerterom" },
  { municipality: "Enebakk", slogan: "Mulighetenes Enebakk" },
  { municipality: "Engerdal", slogan: "Helt naturlig" },
  { municipality: "Etne", slogan: "Me gjere dè i Etne!" },
  { municipality: "Etnedal", slogan: "Minst og best" },
  { municipality: "Evenes", slogan: "Midt i opplevelsen" },
  { municipality: "Evje og Hornnes", slogan: "Hjertet i Agder" },
  { municipality: "Farsund", slogan: "Kysten er klar" },
  { municipality: "Fauske-Fuosko", slogan: "Folkehelsekommunen der alle trives" },
  { municipality: "Fjaler", slogan: "Eit ope samfunn" },
  { municipality: "Flatanger", slogan: "Aktivt og åpent" },
  { municipality: "Flekkefjord", slogan: "Vilje til vekst" },
  { municipality: "Flå", slogan: "Flå – Først i Hallingdal" },
  { municipality: "Folldal", slogan: "Lys i alle grender – folk i alle hus" },
  { municipality: "Fredrikstad", slogan: "Det årnær sæ" },
  { municipality: "Froland", slogan: "Enkelt og greit" },
  { municipality: "Frosta", slogan: "Først og fremst" },
  { municipality: "Frøya", slogan: "Kraft og mangfold" },
  { municipality: "Færder", slogan: "Med vind i seilene" },
  { municipality: "Gamvik", slogan: "På toppen av Norge" },
  { municipality: "Gausdal", slogan: "Offensiv og spennende" },
  { municipality: "Gildeskål", slogan: "…Å eg veit meg eit land…" },
  { municipality: "Giske", slogan: "Historisk og fremtidsretta" },
  { municipality: "Gjemnes", slogan: "Godt å leve, trygt å bo" },
  { municipality: "Gjerdrum", slogan: "Nærmere enn du tror" },
  { municipality: "Gjerstad", slogan: "Best når det gjelder" },
  { municipality: "Gjesdal", slogan: "Vi strekker oss lenger" },
  { municipality: "Gjøvik", slogan: "Motor for vekst og utvikling" },
  { municipality: "Gol", slogan: "Me sjåast på Gol" },
  { municipality: "Gran", slogan: "Gran kommune – inkluderende, stolt og nyskapende" },
  { municipality: "Grane", slogan: "Midt i blinken" },
  { municipality: "Gratangen", slogan: "Et sted å bli glad i" },
  { municipality: "Grimstad", slogan: "Med viten og vilje" },
  { municipality: "Grong", slogan: "Kraft i elver og folk" },
  { municipality: "Grue", slogan: "Den vesle kjempen" },
  { municipality: "Gulen", slogan: "Historisk og fremtidsretta" },
  { municipality: "Hadsel", slogan: "Et hav av muligheter" },
  { municipality: "Halden", slogan: "Fjord- og festningsbyen" },
  { municipality: "Hamar", slogan: "Alle tiders by" },
  { municipality: "Hamarøy", slogan: "Æventyrlandet" },
  { municipality: "Hammerfest", slogan: "Vit at æ elske dæ" },
  { municipality: "Harstad", slogan: "Attraktiv hele livet" },
  { municipality: "Hasvik", slogan: "Storfiskens rike" },
  { municipality: "Heim", slogan: "Inkluderende med store muligheter" },
  { municipality: "Hemnes", slogan: "Skaperglede mellom smul sjø og evig snø" },
  { municipality: "Hemsedal", slogan: "Natur, kultur og livskvalitet" },
  { municipality: "Herøy (Møre og Romsdal)", slogan: "Ei båtlengd føre" },
  { municipality: "Hitra", slogan: "Hitra – når du vil!" },
  { municipality: "Hjartdal", slogan: "Bygder med fortid og framtid" },
  { municipality: "Hjelmeland", slogan: "Hjelmeland naturlegvis" },
  { municipality: "Hol", slogan: "Nasjonalparkkommunen" },
  { municipality: "Hole", slogan: "Eventyrlig fortid – eventyrlig fremtid" },
  { municipality: "Holtålen", slogan: "Mulighetenes kommune" },
  { municipality: "Horten", slogan: "Et regionalt senter for kunnskap og opplevelser" },
  { municipality: "Hyllestad", slogan: "Inkluderande og attraktiv" },
  { municipality: "Høyanger", slogan: "Eld Kraft Vatn" },
  { municipality: "Høylandet", slogan: "Fly så høyt du vil med begge beina på jorda" },
  { municipality: "Hå", slogan: "Me løfter i lag" },
  { municipality: "Ibestad", slogan: "Hvor alt er mulig" },
  { municipality: "Inderøy", slogan: "Best i lag" },
  { municipality: "Indre Østfold", slogan: "På kornet" },
  { municipality: "Iveland", slogan: "Et godt sted å bo" },
  { municipality: "Jevnaker", slogan: "Fra Rock til Rullator" },
  { municipality: "Kárášjohka-Karasjok", slogan: "Den samiske pulsåren – bygda der kulturer møtes" },
  { municipality: "Karlsøy", slogan: "Et levende øyrike" },
  { municipality: "Karmøy", slogan: "Sammen om fremtidens Karmøy" },
  { municipality: "Guovdageaidnu-Kautokeino", slogan: "Veiviseren i Sápmi" },
  { municipality: "Klepp", slogan: "Med blikk for alle" },
  { municipality: "Kragerø", slogan: "Perlen blant kystbyene" },
  { municipality: "Kristiansand", slogan: "En by for alle" },
  { municipality: "Kristiansund", slogan: "I medvind uansett vær" },
  { municipality: "Krødsherad", slogan: "Vertskap i verdensklasse" },
  { municipality: "Kvam", slogan: "Framtida er her" },
  { municipality: "Kvinesdal", slogan: "Vakker, vennlig og vågal" },
  { municipality: "Kvinnherad", slogan: "Fellesskap og trivsel, utvikling og vekst" },
  { municipality: "Kvænangen", slogan: "Naturpærle på 70 grader nord" },
  { municipality: "Larvik", slogan: "Der det gode livet lever" },
  { municipality: "Lebesby", slogan: "Europas nordligste fastland – Norges vakreste havklippe" },
  { municipality: "Leirfjord", slogan: "Muligheter på land og på vann" },
  { municipality: "Levanger", slogan: "Triveligst i Trøndelag" },
  { municipality: "Lier", slogan: "Grønne Lier for alle innbyggere" },
  { municipality: "Lierne", slogan: "Det gode vertskap" },
  { municipality: "Lillehammer", slogan: "Opplevelser. Slik du vil ha dem" },
  { municipality: "Lillesand", slogan: "Vi tenker helhetlig" },
  { municipality: "Lindesnes", slogan: "På lag med framtida" },
  { municipality: "Lom", slogan: "Kom til Lom" },
  { municipality: "Loppa", slogan: "Dra på Lopphavet – Et hav av muligheter" },
  { municipality: "Lunner", slogan: "Nær naturen – Nær byen" },
  { municipality: "Lurøy", slogan: "Liv laga" },
  { municipality: "Lyngdal", slogan: "Vi vil – vi våger" },
  { municipality: "Lyngen", slogan: "Alpekommunen i nord" },
  { municipality: "Lødingen", slogan: "Bygda som sykler" },
  { municipality: "Løten", slogan: "Midtpunkt med mangfold" },
  { municipality: "Malvik", slogan: "Åpen, nyskapende og samhandlende" },
  { municipality: "Marker", slogan: "Mulighetene er mange" },
  { municipality: "Masfjorden", slogan: "Ein kommune me er stolte av" },
  { municipality: "Melhus", slogan: "Melhus er en mangfoldig kommune der det skal være mulig å være modig" },
  { municipality: "Meløy", slogan: "Raus og kraftfull" },
  { municipality: "Meråker", slogan: "Mulighetene er mange" },
  { municipality: "Midtre Gauldal", slogan: "Der vi møtes" },
  { municipality: "Modalen", slogan: "Liten kommune – Stor kraft!" },
  { municipality: "Modum", slogan: "Vi strekker oss lenger" },
  { municipality: "Molde", slogan: "Vi strekker oss langt!" },
  { municipality: "Moss", slogan: "Ja vi elsker Moss" },
  { municipality: "Målselv", slogan: "Mulighetslandet" },
  { municipality: "Måsøy", slogan: "Kystens perle" },
  { municipality: "Namsos", slogan: "Et godt sted å leve" },
  { municipality: "Namsskogan", slogan: "Toppen i Namdalen!" },
  { municipality: "Nannestad", slogan: "Ei grønn bygd i vekst" },
  { municipality: "Narvik", slogan: "Narvik inspirerer!" },
  { municipality: "Nesodden", slogan: "Sammen skaper vi det gode livet" },
  { municipality: "Unjárga-Nesseby", slogan: "En sjøsamisk kommune" },
  { municipality: "Nittedal", slogan: "Der storby møter marka" },
  { municipality: "Nord-Aurdal", slogan: "Regionsenteret i Valdres" },
  { municipality: "Nord-Fron", slogan: "Det attraktive midtpunktet i Gudbrandsdalen" },
  { municipality: "Nord-Odal", slogan: "En servicekommune" },
  { municipality: "Notodden", slogan: "Bluesbyen" },
  { municipality: "Oppdal", slogan: "Det gode liv i ei attraktiv fjellbygd" },
  { municipality: "Orkland", slogan: "Modig – klok – nær" },
  { municipality: "Osen", slogan: "Et Norge i miniatyr" },
  { municipality: "Oslo-Oslove", slogan: "Unanimiter et constanter" },
  { municipality: "Overhalla", slogan: "Positiv, frisk og framsynt" },
  { municipality: "Porsgrunn", slogan: "Sammen om Porsgrunn" },
  { municipality: "Rakkestad", slogan: "Den trivelige kommune" },
  { municipality: "Randaberg", slogan: "Sammen skaper vi den grønne landsbyen" },
  { municipality: "Rauma", slogan: "Verdens beste kommune for naturglade mennesker" },
  { municipality: "Rendalen", slogan: "Åpenhet – raushet – engasjement" },
  { municipality: "Rindal", slogan: "Porten til Trollheimen" },
  { municipality: "Ringebu", slogan: "Det er lov å lykkes" },
  { municipality: "Ringerike", slogan: "Nærmest det meste" },
  { municipality: "Ringsaker", slogan: "Midt i væla" },
  { municipality: "Risør", slogan: "Den hvite by ved Skagerak" },
  { municipality: "Rælingen", slogan: "Trivselskommunen med nærhet til Østmarka og Øyeren" },
  { municipality: "Rødøy", slogan: "Kystfolket under polarsirkelen" },
  { municipality: "Røros", slogan: "Pulsen i fjellet" },
  { municipality: "Råde", slogan: "Bygda mellom byene" },
  { municipality: "Salangen", slogan: "Sprenger grenser" },
  { municipality: "Saltdal", slogan: "Imøtekommende, løsningsfokusert og ansvarlig" },
  { municipality: "Samnanger", slogan: "Der du vil leva og bu" },
  { municipality: "Sande", slogan: "Utanfor allfarveg – heldigvis" },
  { municipality: "Sandefjord", slogan: "Sammen framover" },
  { municipality: "Selbu", slogan: "Et lykkeland" },
  { municipality: "Senja", slogan: "Raus, framoverlent, bærekraftig" },
  { municipality: "Sigdal", slogan: "Kunstnerdalen" },
  { municipality: "Siljan", slogan: "Den gode bostedskommunen" },
  { municipality: "Sirdal", slogan: "Meir enn ryper" },
  { municipality: "Skaun", slogan: "Aktiv og attraktiv – sammen" },
  { municipality: "Skien", slogan: "Den gode og inkluderende møteplass" },
  { municipality: "Skiptvet", slogan: "Klart vi kan" },
  { municipality: "Skjervøy", slogan: "Kystbyen i Nord-Troms" },
  { municipality: "Skjåk", slogan: "Vekst og styrke" },
  { municipality: "Smøla", slogan: "Øy i et hav av muligheter" },
  { municipality: "Sokndal", slogan: "Det gode liv i Sokndal" },
  { municipality: "Stavanger", slogan: "Vi bygger fellesskap" },
  { municipality: "Steigen", slogan: "Kyst som gir lyst" },
  { municipality: "Steinkjer", slogan: "Åpen, lys og glad" },
  { municipality: "Stjørdal", slogan: "Et godt valg for framtida" },
  { municipality: "Stor-Elvdal", slogan: "Midt i Østerdalen" },
  { municipality: "Stord", slogan: "Liten by for det heilt store" },
  { municipality: "Storfjord-Omasvuotna-Omasvuono", slogan: "Mangfold styrker" },
  { municipality: "Sunndal", slogan: "Vill og vakker" },
  { municipality: "Sveio", slogan: "Sveio, midt i leio" },
  { municipality: "Sykkylven", slogan: "Skaparkraft" },
  { municipality: "Søndre Land", slogan: "Levende og landlig ved Randsfjorden" },
  { municipality: "Sør-Aurdal", slogan: "Først i Valdres" },
  { municipality: "Sør-Fron", slogan: "Dalernes blomme" },
  { municipality: "Sør-Odal", slogan: "Nærmere enn du tror" },
  { municipality: "Sør-Varanger", slogan: "En grensesprengende kommune" },
  { municipality: "Sørfold", slogan: "Fjell møter fjord" },
  { municipality: "Time", slogan: "Me skal gjera kvarandre gode" },
  { municipality: "Tingvoll", slogan: "Økokommunen, bedre løsninger for mennesker og miljø" },
  { municipality: "Tolga", slogan: "Kommune med tæl" },
  { municipality: "Trysil", slogan: "Stavtaket foran" },
  { municipality: "Tvedestrand", slogan: "Tiden på din side" },
  { municipality: "Tynset", slogan: "Kjem'n te Tynset så trivs'n" },
  { municipality: "Tysnes", slogan: "Gudeøya Tysnes, framtid på historisk grunn" },
  { municipality: "Tønsberg", slogan: "Der barn ler" },
  { municipality: "Ullensvang", slogan: "Noregs frukthage" },
  { municipality: "Ulstein", slogan: "Der baug bryt båre" },
  { municipality: "Ulvik", slogan: "Perla i Hardanger" },
  { municipality: "Utsira", slogan: "Utsira gir energi" },
  { municipality: "Vadsø", slogan: "Kvenhovedstaden" },
  { municipality: "Vaksdal", slogan: "Bynært bygdeliv" },
  { municipality: "Valle", slogan: "Gjestfri for nye tankar" },
  { municipality: "Vang", slogan: "Vilt og vakkert" },
  { municipality: "Vanylven", slogan: "Ein grunn til å smile" },
  { municipality: "Vardø", slogan: "Cedant tenebræ Soli" },
  { municipality: "Vefsn", slogan: "Et steg foran" },
  { municipality: "Vegårshei", slogan: "Levende og inkluderende" },
  { municipality: "Verdal", slogan: "Sterk fortid – stolt framtid" },
  { municipality: "Vestnes", slogan: "Midt i blinken!" },
  { municipality: "Vestre Slidre", slogan: "Heilt naturleg – ekta vare" },
  { municipality: "Vestre Toten", slogan: "Trygghet, trivsel og utvikling" },
  { municipality: "Vindafjord", slogan: "Vital og sentral" },
  { municipality: "Vågå", slogan: "Våken og Vågal i Vågå" },
  { municipality: "Våler (Innlandet)", slogan: "Et gir ekstra" },
  { municipality: "Ørsta", slogan: "Hjartet av Sunnmørsalpane" },
  { municipality: "Øvre Eiker", slogan: "Sammen skaper vi et livskraftig Øvre Eiker" },
  { municipality: "Øystre Slidre", slogan: "Rein naturglede!" },
  { municipality: "Åfjord", slogan: "Kom til Åfjord, da vel!" },
  { municipality: "Ål", slogan: "Kulturkommunen" },
  { municipality: "Åmli", slogan: "Bygda for alle" },
  { municipality: "Åmot", slogan: "Vilje til vekst" },
  { municipality: "Årdal", slogan: "Ein god kommune å bu, leva og arbeide i" },
  { municipality: "Ås", slogan: "Miljø, mangfold og muligheter" },
  { municipality: "Åseral", slogan: "Ei positiv kraft" },
  { municipality: "Åsnes", slogan: "Inkluderende og miljøbevist" },
];

const sloganByMunicipality = new Map(
  SLOGANS.map((entry) => [entry.municipality, entry.slogan])
);

// Only municipalities with a known slogan can be picked by Slagordle.
export const countriesWithSlogan = countries.filter((c) =>
  sloganByMunicipality.has(c.name)
);

export function getSlogan(country: Country): string {
  return sloganByMunicipality.get(country.name) ?? "";
}
